// ©2024 Austin App House. All rights reserved.
import React from 'react';
// removed MDBReact usage

const detailTitleStyles = { marginRight: '10px', cursor: 'pointer' };
const detailValueGreenStyles = { marginRight: '10px', color: '#009933' };
const addressBlockStyles = { minHeight: '35px' };

const ContractorDetails = ({
  contractorDetails = null,
}) => (
  <>
    <div className="view_profile">
      <div className="profile_main">
        <div className="info_block">
          <div className="user_position">
            ID: {contractorDetails.unique_id}
          </div>
          <div className="user_name">
            Name: {contractorDetails.name}
          </div>
          <div className="sign_info">
            Date Registered: {new Date(contractorDetails.date).toLocaleDateString('en-US', { timeZone: 'UTC' })}
          </div>
          <div className="sign_info">
            Last WO completed date: {new Date(contractorDetails.lastWorkOrderCompletedAt).toLocaleDateString('en-US', { timeZone: 'UTC' })}
          </div>
          <div className="sign_info">
            Work Performed: {`${contractorDetails.completedWorkOrderCount || 0} / ${contractorDetails.allWorkOrdersCount || 0}`}
          </div>
        </div>
          <div className="image_block">
            <img
              src={contractorDetails.image || 'https://www.w3schools.com/css/img_avatar.png'}
              alt="Avatar"
            />
          </div>
      </div>

      <ul className="profile_contacts">
        <li>
          <div className="profile_label">Address</div>
          <div className="profile_info">
          {contractorDetails.address || ''}
          {contractorDetails.address2 !== 'undefined' && contractorDetails.address !== '' ? `, ${contractorDetails.address2}` : ''}
          {(contractorDetails.city && contractorDetails.city.label) ? `, ${contractorDetails.city.label}` : ''}
          {(contractorDetails.state && contractorDetails.state.value) ? `, ${contractorDetails.state.label}` : ''}
          {contractorDetails.zipcode ? `, ${contractorDetails.zipcode}` : ''}
          {(contractorDetails.country && contractorDetails.country.value) ? `, ${contractorDetails.country.label}` : ''}
          </div>
        </li>
        <li>
          <div className="profile_label">Website</div>
          <div className="profile_info">
            <a href={contractorDetails.website !== 'undefined' ? contractorDetails.website : ''} target="_blank" rel="noopener noreferrer">
              {contractorDetails.website !== 'undefined' ? contractorDetails.website : ''}
            </a>
          </div>
        </li>
        <li>
          <div className="profile_label">Phone</div>
          <div className="profile_info">
            <a href={contractorDetails.phone !== 'undefined' ? `tel:${contractorDetails.phone}` : ''}>
              {contractorDetails.phone !== 'undefined' ? contractorDetails.phone : ''}
            </a>
          </div>
        </li>
        <li>
          <div className="profile_label">Email</div>
          <div className="profile_info">
            <a href={contractorDetails.email !== 'undefined' ? `mailto:${contractorDetails.email}` : ''}>
              {contractorDetails.email !== 'undefined' ? contractorDetails.email : ''}
            </a>
          </div>
        </li>
      </ul>
    </div>
  </>
);

export default ContractorDetails;
